import { FileRepository } from "@api/repositories/FileRepository";
import EventEdit from "@share/event-edit/EventEdit.vue";

export class FileChangeObserver {
    isFileUploading = false;

    constructor(
        private readonly repository: FileRepository,
        private readonly component: EventEdit
    ) {
    }

    async handle(file: File) {
        this.isFileUploading = true;
        try {
            const uploadedFile = await this.repository.create(file, file.name);
            if (this.component.event?.base) {
                this.component.event.base.stageFileId = uploadedFile.id as string;
            }
        }
        catch (e) {
            this.component.$store.dispatch('reportException', e);
        }
        this.isFileUploading = false;
    }
}